// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.fa-check-circle {
  color: green;
}
.fa-times-circle {
  color: red;
}
`, "",{"version":3,"sources":["webpack://./src/components/TickOrCross.vue"],"names":[],"mappings":";AAmBA;EACE,YAAY;AACd;AAEA;EACE,UAAU;AACZ","sourcesContent":["<template>\r\n  <i :class=\"{\r\n    'fa-check-circle': tick,\r\n    'fa-times-circle': !tick\r\n  }\" class=\"fa\"></i>\r\n</template>\r\n\r\n<script setup>\r\nconst props = defineProps(\r\n    {\r\n      tick: {\r\n        type: Boolean,\r\n        required: true\r\n      }\r\n    }\r\n)\r\n</script>\r\n\r\n<style>\r\n.fa-check-circle {\r\n  color: green;\r\n}\r\n\r\n.fa-times-circle {\r\n  color: red;\r\n}\r\n</style>\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
